// extracted by mini-css-extract-plugin
export default {"main":"fOgGlKTShrBPXZGMFL3J1w=="};